import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import plantAI from "../../Assets/Projects/plant.png";
import documentClassification from "../../Assets/Projects/document.png";
import fraudDetection from "../../Assets/Projects/fraud.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fraudDetection}
              isBlog={false}
              title="Fraud Detection System"
              description="Developed a fraud detection system using machine learning algorithms like Random Forest and XGBoost. The system analyzes banking transactions and identifies potentially fraudulent activities with an accuracy of 95%."
              ghLink="https://github.com/BaselAshraf81"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={documentClassification}
              isBlog={false}
              title="Document Classification System"
              description="Built a document classification system for financial documents using natural language processing techniques. Implemented deep learning models with TensorFlow to classify documents accurately, achieving an accuracy of 98%."
              ghLink="https://github.com/BaselAshraf81"
              demoLink=""
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plantAI}
              isBlog={false}
              title="Plant Disease Detection"
              description="Trained a convolutional neural network (CNN) model to detect plant diseases from images. Used transfer learning with pre-trained models like ResNet34 to achieve an accuracy of 98%. The system can identify 38 classes of plant diseases."
              ghLink="https://github.com/BaselAshraf81"
              demoLink=""
            />
          </Col>




        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
